import { useState } from "react";
import {
  Container, Row, Col, FormGroup, Label, Input, Button, Alert,
} from "reactstrap";
import { useTranslation } from "react-i18next";

// Payment links — replace "#" with real QPayPro links when ready
const PAYMENT_LINKS = {
  noestudiante_full: "https://app.recurrente.com/s/asociacion-guatemalteca-de-ingenieria-y-ciencias-espaciales/profesional-completo-early-bird-dmprpl",
  universitario_full: "https://app.recurrente.com/s/asociacion-guatemalteca-de-ingenieria-y-ciencias-espaciales/estudiante-universitario-completo",
  colegio_full: "https://app.recurrente.com/s/asociacion-guatemalteca-de-ingenieria-y-ciencias-espaciales/estudiante-de-colegio-completo",
  padre_full: "https://app.recurrente.com/s/asociacion-guatemalteca-de-ingenieria-y-ciencias-espaciales/padre-de-familia-completo",
  noestudiante_day: "https://app.recurrente.com/s/asociacion-guatemalteca-de-ingenieria-y-ciencias-espaciales/profesion-un-dia-early-bird",
  universitario_day: "https://app.recurrente.com/s/asociacion-guatemalteca-de-ingenieria-y-ciencias-espaciales/estudiantes-universitario-un-dia-early-bird",
  colegio_day: "https://app.recurrente.com/s/asociacion-guatemalteca-de-ingenieria-y-ciencias-espaciales/estudiante-de-colegio-un-dia-early-bird",
  padre_day: "https://app.recurrente.com/s/asociacion-guatemalteca-de-ingenieria-y-ciencias-espaciales/padre-de-familia-un-dia-early-bird",
};

export const RegistrationContent = () => {
  const { t } = useTranslation();

  const initialForm = {
    treatment: "",
    firstName: "",
    lastName: "",
    birthDate: "",
    sex: "",
    indigenous: "",
    indigenousGroup: "",
    institution: "",
    nationality: "",
    country: "",
    profession: "",
    email: "",
    category: "",
    transactionId: "",
    consent: false,
    _honeypot: "",
  };

  const [formData, setFormData] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [alert, setAlert] = useState({ type: "", msg: "" });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const formValid =
    formData.treatment &&
    formData.firstName.trim() &&
    formData.lastName.trim() &&
    formData.birthDate &&
    formData.sex &&
    formData.indigenous &&
    (formData.indigenous === "no" || formData.indigenousGroup.trim()) &&
    formData.institution.trim() &&
    formData.nationality.trim() &&
    formData.country.trim() &&
    formData.profession.trim() &&
    formData.email.trim() &&
    /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(formData.email) &&
    formData.category &&
    formData.transactionId.trim() &&
    formData.consent;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlert({ type: "", msg: "" });

    if (formData._honeypot) return;

    if (!formValid) {
      setAlert({ type: "warning", msg: t("reg_form_incomplete") });
      return;
    }

    const SCRIPT_URL = process.env.REACT_APP_GOOGLE_SHEETS_URL;

    if (!SCRIPT_URL) {
      setAlert({ type: "danger", msg: t("reg_form_error") });
      console.error("REACT_APP_GOOGLE_SHEETS_URL is not defined in .env");
      return;
    }

    try {
      setSubmitting(true);

      const payload = {
        timestamp: new Date().toLocaleString("es-GT", { timeZone: "America/Guatemala" }),
        treatment: formData.treatment,
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        birthDate: formData.birthDate,
        sex: formData.sex,
        indigenous: formData.indigenous,
        indigenousGroup: formData.indigenousGroup || "N/A",
        institution: formData.institution,
        nationality: formData.nationality,
        country: formData.country,
        profession: formData.profession,
        category: formData.category,
        transactionId: formData.transactionId,
      };

      await fetch(SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      setAlert({ type: "success", msg: t("reg_form_success") });
      setFormData(initialForm);
    } catch (err) {
      console.error("Registration error:", err);
      setAlert({ type: "danger", msg: t("reg_form_error") });
    } finally {
      setSubmitting(false);
    }
  };

  const inputStyle = { borderRadius: "8px" };
  const labelStyle = { color: "#333333", fontWeight: "500" };
  const requiredStar = <span style={{ color: "#dc3545", fontWeight: "bold" }}> *</span>;

  const renderTierCards = (tiers) =>
    tiers.map((tier, idx) => (
      <Col md="6" lg="3" key={idx} className="mb-4">
        <div style={{
          background: tier.gradient,
          borderRadius: "15px",
          padding: "2rem 1.5rem",
          color: "white",
          textAlign: "center",
          boxShadow: `0 10px 30px ${tier.shadow}`,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          transition: "transform 0.3s ease",
        }}
          onMouseOver={(e) => { e.currentTarget.style.transform = "translateY(-5px)"; }}
          onMouseOut={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}
        >
          <div style={{ minHeight: "7rem", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <span style={{ fontSize: "2.5rem", marginBottom: "0.5rem" }}>{tier.icon}</span>
            <h4 style={{ fontWeight: "bold", color: "white", marginBottom: "0", whiteSpace: "pre-line" }}>
              {t(`reg_tier_${tier.key}`)}
            </h4>
          </div>

          {/* Early - finalizado */}
          <div style={{ padding: "0.5rem 0.8rem", width: "100%", borderRadius: "10px", marginTop: "0.5rem", opacity: 0.5 }}>
            <p style={{ fontSize: "0.7rem", marginBottom: "0.1rem", textTransform: "uppercase", letterSpacing: "1px", textDecoration: "line-through" }}>
              Early
            </p>
            <p style={{ fontSize: "1rem", fontWeight: "500", margin: 0, color: "white", textDecoration: "line-through" }}>
              {tier.early}
            </p>
          </div>

          {/* Regular - clickable */}
          <a
            href={PAYMENT_LINKS[`${tier.key}`]}
            target="_blank"
            rel="noreferrer"
            style={{
              background: "rgba(255,255,255,0.2)",
              borderRadius: "10px",
              padding: "0.8rem",
              marginBottom: "0.5rem",
              width: "100%",
              marginTop: "0.3rem",
              textDecoration: "none",
              color: "white",
              display: "block",
              transition: "all 0.3s ease",
              cursor: "pointer",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.35)";
              e.currentTarget.style.transform = "scale(1.03)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.2)";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem", opacity: 0.9, textTransform: "uppercase", letterSpacing: "1px" }}>
              Regular
            </p>
            <p style={{ fontSize: "1.8rem", fontWeight: "bold", margin: 0, color: "white" }}>
              {tier.regular}
            </p>
          </a>
        </div>
      </Col>
    ));

  const fullTiers = [
    { icon: "💼", key: "noestudiante_full", gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", shadow: "rgba(102, 126, 234, 0.3)", early: "$130", regular: "$150", late: "$175" },
    { icon: "🎓", key: "universitario_full", gradient: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)", shadow: "rgba(17, 153, 142, 0.3)", early: "$74", regular: "$80", late: "$99" },
    { icon: "📚", key: "colegio_full", gradient: "linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%)", shadow: "rgba(91, 134, 229, 0.3)", early: "$35", regular: "$40", late: "$47" },
    { icon: "👨‍👩‍👧", key: "padre_full", gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)", shadow: "rgba(245, 87, 108, 0.3)", early: "$74", regular: "$80", late: "$99" },
  ];

  const dayTiers = [
    { icon: "💼", key: "noestudiante_day", gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", shadow: "rgba(102, 126, 234, 0.3)", early: "$87", regular: "$100", late: "$117" },
    { icon: "🎓", key: "universitario_day", gradient: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)", shadow: "rgba(17, 153, 142, 0.3)", early: "$48", regular: "$55", late: "$64" },
    { icon: "📚", key: "colegio_day", gradient: "linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%)", shadow: "rgba(91, 134, 229, 0.3)", early: "$26", regular: "$30", late: "$35" },
    { icon: "👨‍👩‍👧", key: "padre_day", gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)", shadow: "rgba(245, 87, 108, 0.3)", early: "$48", regular: "$55", late: "$64" },
  ];

  return (
    <div style={{ paddingTop: "60px", paddingBottom: "60px", backgroundColor: "#f8f9fa" }}>
      <Container>

        {/* Título */}
        <Row className="mb-5">
          <Col>
            <h1 className="text-center" style={{ color: "#333333", fontWeight: "bold", marginBottom: "1rem" }}>
              {t("reg_title")}
            </h1>
            <p className="text-center lead" style={{ color: "#666666" }}>
              {t("reg_lead")}
            </p>
          </Col>
        </Row>

        {/* Pasos a seguir */}
        <Row className="mb-5">
          <Col>
            <div className="d-flex justify-content-center align-items-start flex-wrap gap-2">
              {[
                { icon: "💳", label: t("reg_step_1") },
                { icon: "📧", label: t("reg_step_2") },
                { icon: "📝", label: t("reg_step_3") },
              ].map((step, idx, arr) => (
                <div key={idx} className="d-flex align-items-start">
                  <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    width: "160px",
                  }}>
                    <div style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1.5rem",
                      boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                      marginBottom: "0.5rem",
                      color: "white",
                      fontWeight: "bold",
                      flexShrink: 0,
                    }}>
                      {step.icon}
                    </div>
                    <span style={{ color: "#555", fontWeight: "600", fontSize: "0.85rem" }}>
                      {step.label}
                    </span>
                  </div>
                  {idx < arr.length - 1 && (
                    <span style={{ fontSize: "1.5rem", color: "#764ba2", margin: "0 0.5rem", marginTop: "15px" }}>→</span>
                  )}
                </div>
              ))}
            </div>
          </Col>
        </Row>

        {/* Instrucciones de pago */}
        <Row className="mb-5">
          <Col md={{ size: 10, offset: 1 }} lg={{ size: 8, offset: 2 }}>
            <div style={{
              background: "linear-gradient(135deg, #fc4a1a 0%, #f7b733 100%)",
              borderRadius: "15px",
              padding: "2rem",
              boxShadow: "0 10px 30px rgba(252, 74, 26, 0.25)",
              color: "white",
            }}>
              <h4 style={{ fontWeight: "bold", marginBottom: "1rem", color: "white" }}>
                📋 {t("reg_payment_instructions_title")}
              </h4>
              <p style={{ lineHeight: "1.8", marginBottom: "0.8rem", textAlign: "justify" }}>
                {t("reg_payment_instructions_text")}
              </p>
              <p style={{ lineHeight: "1.8", marginBottom: "0.8rem", textAlign: "justify" }}>
                <strong>{t("reg_payment_instructions_bold")}</strong>
              </p>
              <p style={{ lineHeight: "1.8", marginBottom: 0, textAlign: "justify" }}>
                {t("reg_payment_instructions_note")}
              </p>
            </div>
          </Col>
        </Row>

        {/* Tarifas */}
        <Row className="mb-4">
          <Col>
            <h2 className="text-center mb-3" style={{ color: "#333333", fontWeight: "600" }}>
              {t("reg_pricing_title")}
            </h2>
            <p className="text-center mb-4" style={{ color: "#555", fontSize: "1.1rem" }}>
              {t("reg_pricing_subtitle")}
            </p>
            <h4 className="text-center mb-3" style={{ color: "#555", fontWeight: "600" }}>
              {t("reg_pricing_full")}
            </h4>
            <Row className="justify-content-center">
              {renderTierCards(fullTiers)}
            </Row>

            {/* Un día */}
            <h4 className="text-center mt-4 mb-3" style={{ color: "#555", fontWeight: "600" }}>
              {t("reg_pricing_oneday")}
            </h4>
            <Row className="justify-content-center">
              {renderTierCards(dayTiers)}
            </Row>

            {/* No refund */}
            <div className="text-center mt-3">
              <div style={{
                display: "inline-block",
                background: "#fff3cd",
                color: "#856404",
                padding: "0.75rem 1.5rem",
                borderRadius: "10px",
                fontWeight: "500",
              }}>
                ⚠️ {t("reg_no_refund")}
              </div>
            </div>
          </Col>
        </Row>

        {/* Formulario */}
        <Row className="mb-5">
          <Col lg={{ size: 10, offset: 1 }}>
            <div style={{
              background: "white",
              borderRadius: "15px",
              padding: "2.5rem",
              boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
            }}>
              <h2 className="text-center mb-4" style={{ color: "#333333", fontWeight: "600" }}>
                {t("reg_form_title")}
              </h2>

              {alert.msg && (
                <Alert color={alert.type} role="alert" aria-live="polite">
                  {alert.msg}
                </Alert>
              )}

              <form onSubmit={handleSubmit} noValidate>
                {/* Honeypot */}
                <div style={{ position: "absolute", left: "-10000px", height: 0, overflow: "hidden" }} aria-hidden="true">
                  <label htmlFor="_honeypot">Do not fill</label>
                  <input type="text" id="_honeypot" name="_honeypot" value={formData._honeypot} onChange={handleChange} tabIndex={-1} />
                </div>

                {/* Pago */}
                <h5 className="mb-3" style={{ color: "#333", fontWeight: "600", borderBottom: "2px solid #667eea", paddingBottom: "0.5rem" }}>
                  💳 {t("reg_payment_instructions_title")}
                </h5>
                <Row className="mb-4">
                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="category" style={labelStyle}>{t("reg_category")}{requiredStar}</Label>
                      <Input type="select" name="category" id="category" value={formData.category} onChange={handleChange} style={inputStyle}>
                        <option value="">{t("reg_select")}</option>
                        <optgroup label={t("reg_pricing_full")}>
                          <option value="No Estudiante – Regular">{t("reg_cat_noest_full")}</option>
                          <option value="Estudiante Universitario – Regular">{t("reg_cat_uni_full")}</option>
                          <option value="Estudiante Colegio – Regular">{t("reg_cat_col_full")}</option>
                          <option value="Padre de Familia – Regular">{t("reg_cat_padre_full")}</option>
                        </optgroup>
                        <optgroup label={t("reg_pricing_oneday")}>
                          <option value="No Estudiante 1 día – Regular">{t("reg_cat_noest_day")}</option>
                          <option value="Estudiante Universitario 1 día – Regular">{t("reg_cat_uni_day")}</option>
                          <option value="Estudiante Colegio 1 día – Regular">{t("reg_cat_col_day")}</option>
                          <option value="Padre de Familia 1 día – Regular">{t("reg_cat_padre_day")}</option>
                        </optgroup>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="transactionId" style={labelStyle}>{t("reg_transaction_id")}{requiredStar}</Label>
                      <Input type="text" name="transactionId" id="transactionId" value={formData.transactionId} onChange={handleChange} style={inputStyle} placeholder={t("reg_transaction_id_placeholder")} />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Datos personales */}
                <h5 className="mb-3" style={{ color: "#333", fontWeight: "600", borderBottom: "2px solid #667eea", paddingBottom: "0.5rem" }}>
                  👤 {t("reg_form_title")}
                </h5>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="treatment" style={labelStyle}>{t("reg_treatment")}{requiredStar}</Label>
                      <Input type="select" name="treatment" id="treatment" value={formData.treatment} onChange={handleChange} style={inputStyle}>
                        <option value="">{t("reg_select")}</option>
                        <option value="Sr.">Sr. / Mr.</option>
                        <option value="Sra.">Sra. / Mrs.</option>
                        <option value="Dr.">Dr. / Dr.</option>
                        <option value="Ing.">Ing. / Eng.</option>
                        <option value="Lcdo/Lcda.">Lcdo/Lcda. / Lic.</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="firstName" style={labelStyle}>{t("reg_first_name")}{requiredStar}</Label>
                      <Input type="text" name="firstName" id="firstName" value={formData.firstName} onChange={handleChange} style={inputStyle} />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="lastName" style={labelStyle}>{t("reg_last_name")}{requiredStar}</Label>
                      <Input type="text" name="lastName" id="lastName" value={formData.lastName} onChange={handleChange} style={inputStyle} />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="email" style={labelStyle}>{t("reg_email")}{requiredStar}</Label>
                      <Input type="email" name="email" id="email" value={formData.email} onChange={handleChange} style={inputStyle} />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="birthDate" style={labelStyle}>{t("reg_birth_date")}{requiredStar}</Label>
                      <Input type="date" name="birthDate" id="birthDate" value={formData.birthDate} onChange={handleChange} style={inputStyle} />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="sex" style={labelStyle}>{t("reg_sex")}{requiredStar}</Label>
                      <Input type="select" name="sex" id="sex" value={formData.sex} onChange={handleChange} style={inputStyle}>
                        <option value="">{t("reg_select")}</option>
                        <option value="Masculino">{t("reg_sex_male")}</option>
                        <option value="Femenino">{t("reg_sex_female")}</option>
                        <option value="Prefiero no decir">{t("reg_sex_prefer_not")}</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label htmlFor="indigenous" style={labelStyle}>{t("reg_indigenous")}{requiredStar}</Label>
                      <Input type="select" name="indigenous" id="indigenous" value={formData.indigenous} onChange={handleChange} style={inputStyle}>
                        <option value="">{t("reg_select")}</option>
                        <option value="si">{t("reg_yes")}</option>
                        <option value="no">{t("reg_no")}</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  {formData.indigenous === "si" && (
                    <Col md="8">
                      <FormGroup>
                        <Label htmlFor="indigenousGroup" style={labelStyle}>{t("reg_indigenous_which")}{requiredStar}</Label>
                        <Input type="text" name="indigenousGroup" id="indigenousGroup" value={formData.indigenousGroup} onChange={handleChange} style={inputStyle} />
                      </FormGroup>
                    </Col>
                  )}
                </Row>

                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="institution" style={labelStyle}>{t("reg_institution")}{requiredStar}</Label>
                      <Input type="text" name="institution" id="institution" value={formData.institution} onChange={handleChange} style={inputStyle} />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="profession" style={labelStyle}>{t("reg_profession")}{requiredStar}</Label>
                      <Input type="text" name="profession" id="profession" value={formData.profession} onChange={handleChange} style={inputStyle} />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="nationality" style={labelStyle}>{t("reg_nationality")}{requiredStar}</Label>
                      <Input type="text" name="nationality" id="nationality" value={formData.nationality} onChange={handleChange} style={inputStyle} />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="country" style={labelStyle}>{t("reg_country")}{requiredStar}</Label>
                      <Input type="text" name="country" id="country" value={formData.country} onChange={handleChange} style={inputStyle} />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Consentimiento */}
                <FormGroup check className="mb-4 mt-2">
                  <Input type="checkbox" id="consent" name="consent" checked={formData.consent} onChange={handleChange} />
                  <Label htmlFor="consent" check style={{ color: "#333", lineHeight: "1.6" }}>
                    <strong>
                      {t("reg_consent_1")}{" "}
                      <a href="/privacy-policy" style={{ color: "#007bff" }}>{t("reg_consent_policy")}</a>{" "}
                      {t("reg_consent_2")}
                    </strong>
                    {requiredStar}
                  </Label>
                </FormGroup>

                {/* Botón */}
                <div className="d-flex justify-content-center">
                  <Button
                    color="primary"
                    size="lg"
                    type="submit"
                    disabled={submitting || !formValid}
                    style={{
                      padding: "12px 50px",
                      fontWeight: "600",
                      letterSpacing: "0.5px",
                      borderRadius: "8px",
                      boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      border: "none",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.5)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.4)";
                    }}
                  >
                    {submitting ? t("reg_submitting") : t("reg_submit")}
                  </Button>
                </div>
              </form>
            </div>
          </Col>
        </Row>

        {/* Contacto */}
        <Row>
          <Col className="text-center">
            <p style={{ color: "#555", fontSize: "1.05rem" }}>
              {t("reg_help")}{" "}
              <a href="mailto:faq@cecspace.org" style={{ color: "#667eea", fontWeight: "500" }}>faq@cecspace.org</a>
            </p>
          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default RegistrationContent;